<page-banner imageUrl="page-banner-1.png" headingText="Change password"></page-banner>

<div class="content-container">
  <div class="container">

    <div class="row">
      <div class="col-12">

        <customer-change-password></customer-change-password>

      </div>
    </div>

  </div>
</div>
